
















import { Consultor, ConsultoresService } from "@/services/consultores.service";
import Vue from "vue";
import Component from "vue-class-component";
import { VModel, Watch } from "vue-property-decorator";

@Component
export default class ConsultorAutoCompleteSelecionado extends Vue {
  @VModel() idConsultor!: number;
  consultor: Consultor | null = null;

  loading = false;

  @Watch("value", { immediate: true })
  fetchConsultor() {
    this.loading = true;
    ConsultoresService.ObterDadosConsultor(this.idConsultor)
      .then((consultor) => (this.consultor = consultor))
      .finally(() => (this.loading = false));
  }
}
